import Products from "@/components/Products/Products"
import Toolbar from "@/components/Toolbar/Toolbar"
import BottomToolbar from "@/components/BottomToolbar/BottomToolbar"
import FilterSidebar from "@/components/FilterSidebar/FilterSidebar"
import SelectedFilters from "@/components/SelectedFilters/SelectedFilters"
import { ContentChildrenProps, wrapContent } from "@/components/ContentWrapper/ContentWrapper"
import NoResults from "@/components/NoResults/NoResults"
import styles from "@/components/Category/Category.module.css"

export function SerpBody({ foundProducts, loading }: ContentChildrenProps) {
  if (!foundProducts && !loading) return <NoResults />
  return (
    <>
      <Toolbar />
      <div className={styles.layout}>
        <div className={styles.sidebar}>
          <FilterSidebar />
        </div>
        <div className={styles.main}>
          <div className={styles.selectedFilters}>
            <SelectedFilters />
          </div>
          <Products />
          <BottomToolbar />
        </div>
      </div>
    </>
  )
}

export default wrapContent("search", SerpBody)
